import { Button } from '@llt-frontend/react-material-button';
import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../styles/pages/oops-page.scss';

// Internal
// --------

function OopsPage() {
  const { t, ready: translationLoaded } = useTranslation('oops-page');

  //
  // Render

  if (!translationLoaded) {
    return null;
  }

  return (
    /* eslint-disable max-len */
    <div className="oops">
      <header className="oops__header">
        <h1>{t('oops')}</h1>
        <p>{t('unexpectedIssue')}</p>
      </header>

      <p>
        <Button contained onClick={() => window.history.back()}>
          {t('goBack')}
        </Button>
      </p>

      <p>
        {`${t('stillHavingIssues')} `}
        <a href="mailto:techsupport@varsitytutors.com">{t('customerSupportTeam')}</a>.
      </p>
    </div>
    /* eslint-enable max-len */
  );
}

// Exports
// -------

export default OopsPage;
